import React, { useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { motion } from "framer-motion";
import { Mail } from "lucide-react";
import { useNotification } from "../components/NotificationContext";
import {forgotPassword} from "../services/userService"
const ForgotPasswordPage = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [error, setError] = useState("");
  const showNotification = useNotification();

const handleForgotPassword = async (e) => {
  e.preventDefault();
  setLoading(true);
  setError("");
  setSuccessMessage("");

  try {
    const response = await forgotPassword(email);

    const message =
      response?.message ||
      "Şifre sıfırlama bağlantısı e-posta adresinize gönderildi.";

    setSuccessMessage(message);
    showNotification(message, "success");
    setEmail("");
  } catch (err) {
    const message =
      err?.response?.data?.message ||
      "İşlem sırasında bir hata oluştu. Lütfen tekrar deneyin.";

    setError(message);
    showNotification(message, "error");
  } finally {
    setLoading(false);
  }
};

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5 }}
      className="min-h-screen py-12 bg-secondary-light"
    >
      <div className="max-w-md container-custom">
        <div className="p-8 bg-white rounded-lg shadow-medium">
          <h1 className="mb-3 text-2xl font-bold text-gray-dark">
            Şifremi Unuttum
          </h1>

          <p className="mb-6 text-gray">
            E-posta adresinizi girin, şifre sıfırlama işlemi için size bağlantı
            gönderelim.
          </p>

          {successMessage && (
            <div className="p-3 mb-4 text-green-600 rounded-md bg-green-50">
              {successMessage}
            </div>
          )}

          {error && (
            <div className="p-3 mb-4 text-red-600 rounded-md bg-red-50">
              {error}
            </div>
          )}

          <form onSubmit={handleForgotPassword}>
            <div className="mb-6">
              <label htmlFor="email" className="block mb-1 text-gray-dark">
                E-posta
              </label>
              <div className="relative">
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="w-full py-2 pl-10 pr-4 border rounded-md focus:outline-none focus:ring-1 focus:ring-primary"
                  placeholder="ornek@mail.com"
                  required
                />
                <Mail
                  className="absolute left-3 top-2.5 text-gray"
                  size={18}
                />
              </div>
            </div>

            <button
              type="submit"
              className="w-full mb-4 btn-primary"
              disabled={loading}
            >
              {loading ? "Gönderiliyor..." : "Şifre Sıfırlama Linki Gönder"}
            </button>
          </form>

          <p className="text-center text-gray">
            <Link to="/login" className="text-primary hover:text-primary-dark">
              Giriş sayfasına dön
            </Link>
          </p>
        </div>
      </div>
    </motion.div>
  );
};

export default ForgotPasswordPage;